/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * ----------------------------------------------------------------------------
 * Account Modal
 * ----------------------------------------------------------------------------
 */
//Get Elements
const modal = document.querySelector(".account-modal");
const account = document.getElementById("account-button");
const span = document.querySelector(".modal-close");
const loginSwitch = document.getElementById("login-switch");
const registerSwitch = document.getElementById("register-switch");
const backToLoginSwitch = document.getElementById("back-to-login-switch");
const passwordRecoverySwitch = document.getElementById("forgot-password-switch");
const loginForm = document.getElementById("login-form-snippet");
const registerForm = document.getElementById("register-form-snippet");
const passwordRecoveryForm = document.getElementById("password-recovery-form-snippet");
const productPage = document.querySelector(".Product");
const productVariantOption = document.querySelectorAll(".HorizontalList__Item");
const productVariantTriggers = document.querySelectorAll(".HorizontalList__Item label");

// Modal
// Open modal on click
account.onclick = () => {
  modal.style.display = "flex";
}
// Close modal on click (x)
span.onclick = () => {
  modal.style.display = "none";
}
// Close when user clicks outside of modal
window.onclick = (event) => {
  if (event.target == modal){
    modal.style.display = "none";
  }
}

// Switch Forms
loginSwitch.onclick = () => {
  loginForm.style.display = "block"
  registerForm.style.display = "none";
  passwordRecoveryForm.style.display = "none";
}
registerSwitch.onclick = () => {
  registerForm.style.display = "block"
  loginForm.style.display = "none"
  passwordRecoveryForm.style.display = "none";
}
passwordRecoverySwitch.onclick = () => {
  passwordRecoveryForm.style.display = "block";
  loginForm.style.display = "none"
  registerForm.style.display = "none";
}
backToLoginSwitch.onclick = () => {
  loginForm.style.display = "block"
  registerForm.style.display = "none";
  passwordRecoveryForm.style.display = "none";
}

//Product Variant Options

for(var i = 0; i < productVariantOption.length; i++) {
  productVariantOption[i].onclick = displayAvailabilityMessage;
}


//Get Selected Option And Display Message
displayAvailabilityMessage();
function displayAvailabilityMessage() {
	let option0 = document.querySelector('.ProductForm__Variants input[name="option-0"]:checked'); 
    option0 = option0 == null ? "" : option0.value;
    option0 = option0.replace('"','').replace(" ","");
    
    let option1 = document.querySelector('.ProductForm__Variants input[name="option-1"]:checked'); 
    option1 = option1 == null ? "" : option1.value;
    option1 = option1.replace('"','').replace(" ","");
    
    let option2 = document.querySelector('.ProductForm__Variants input[name="option-2"]:checked'); 
    option2 = option2 == null ? "" : option2.value;
    option2 = option2.replace('"','').replace(" ","");
    
    let messageIdentifier = ".Product_Variant__" + option0 + "-" + option1 + "-" + option2;
  
  	let productVariantMessages = document.querySelectorAll('.Product__Variant__Inside_Message');
  	for(var i = 0; i < productVariantMessages.length; i++) {
      productVariantMessages[i].style.display = "none";
    }
  
  	if( document.querySelector(messageIdentifier) )
      document.querySelector(messageIdentifier).style.display = "inline";
}

if( productPage != null ) {
  if( document.querySelector("#Estimated_Delivery") ){
    let dispatchData = document.querySelector("#Estimated_Delivery").getAttribute('data-dispatch');
	let dispatchValue = document.querySelector("input[name='" + dispatchData + "']");
    if( dispatchValue )
  		document.querySelector("#Estimated_Delivery").innerHTML = dispatchValue.value;
  }
}

// Sticky Alphabet
var all_letters = document.getElementById("all_letters");
if( all_letters ) {
  var sticky_all_letters = all_letters.offsetTop;

  function make_all_letters_sticky() {
    if ( (window.pageYOffset) > sticky_all_letters+67) {
      all_letters.classList.add("sticky");
    } else {
      all_letters.classList.remove("sticky");
    }
  }
  
  window.onscroll = function() {make_all_letters_sticky()};

}

// Detect Alphabet Scrolling
let letters = document.querySelectorAll('.letter');
let anchor_letters = document.querySelectorAll('.nav-letter');
letters.forEach((elem,idx)=>{
  var waypoint = new Waypoint({
    element: document.getElementById(elem.id),
    handler: function(direction) {
      anchor_letters.forEach((anchor)=>{
        anchor.className = anchor.className.replace(" selected", "");
      });
      console.log('Element:',this.element);
      let anchor_name = 'anchor-' + this.element.id;
      document.querySelector( '#' + anchor_name ).className = document.querySelector( '#' + anchor_name ).className + " selected";
    },
    offset: 50
  })
});

let dups = document.querySelectorAll('#sidebar-menu .Collapsible.underscored');

dups.forEach(( elem )=>{
  	let orig = elem.getAttribute('data-title').slice(0,-1);
  	let selector = elem.previousElementSibling;
	let dup_list = elem.querySelectorAll('.Linklist__Item');
  	dup_list.forEach(function (item) {
        selector.querySelector('.Collapsible__Inner .Linklist').appendChild(item);
    });
  
    elem.style.display = "none";
});

dups.forEach(( elem )=>{
  	let orig = elem.getAttribute('data-title').slice(0,-1);
  	let selector = elem.previousElementSibling;
	let dup_list = elem.querySelectorAll('.Linklist__Item');
  	dup_list.forEach(function (item) {
        selector.querySelector('.Collapsible__Inner .Linklist').appendChild(item);
    });
  
    elem.style.display = "none";
});

// Less padding for instagram
if( document.querySelector('#rap__med__instagram') ){
  let instagram_wrapper = document.querySelector('#rap__med__instagram').parentElement.parentElement.parentElement;
  instagram_wrapper.style.paddingTop = "0px";
  instagram_wrapper.style.paddingBottom = "28px";
  instagram_wrapper.style.marginTop = "-12px";
}

if( document.querySelector('.bold_hidden') ) {
	document.querySelector('.bold_hidden').style.display = 'block';
}

//Product Tabs/Accordion
const tabs = document.querySelectorAll("#Product__Page__Tabs label");

tabs.forEach(function( elem, idx ){
    if( elem ) {
      var checkbox = elem.previousSibling.previousSibling;
      elem.onclick = function() {
        if( checkbox.checked ){
            setTimeout(function(){
              checkbox.checked = false;
          },100);
        }
      }
    }
});